import { Action } from '@ngrx/store';
import { Color } from '@app/models';
import { File } from '@app/models';

export enum ColorActionTypes {
  Load = '[API] Load colors',
  LoadSuccess = '[API] Load colors success',
  LoadFail = '[API] Load colors fail',
  AddOne = '[Color] Add one',
  AddAll = '[Color] Add all',
  Create = '[API] Create color',
  CreateSuccess = '[API] Create color success',
  CreateFail = '[API] Create color fail',
  Update = '[API] Update color',
  UpdateSuccess = '[API] Update color success',
  UpdateFail = '[API] Update color fail',
  UpdateOne = '[Color] Update one',
  ExportColor = '[Color] Export color',
  ExportColorSuccess = '[Color] Export color success',
  ExportColorFail = '[Color] Export color fail',
  GetUploadLink = '[Color] Upload link color',
  GetUploadLinkFail = '[Color] Upload link color fail',
  GetUploadLinkSuccess = '[Color] Upload link color success',
  UploadFile = '[Color] Upload file color',
  UploadFileFail = '[Color] Upload file fail color',
  UploadFileSuccess = '[Color] Upload file success color',
  NotifyFileUpload = '[Color] Notify file upload color',
  ProcessFile = '[API] Process file',
  ProcessFileUpdate = '[API] Process file update',
  ProcessFileFail = '[API] Process file fail',
  ProcessFileSuccess = '[API] Process file success',
  AddPicture = '[Color] Add picture color',
  AddToFileCount = '[Color] Add to file count',
  GetUploadLinkMassive = '[Color] Get upload link massive color',
  GetUploadLinkFailMassive = '[Color] Get upload link fail massive color',
  GetUploadLinkSuccessMassive = '[Color] Get upload link success massive color',
  GetColorsLink = '[Color] Get colors link',
  GetColorsLinkFail = '[Color] Get colors link fail',
  UploadColor = '[Color] Upload color xlsx',
  UploadColorFail = '[Color] Upload color fail xlsx',
  UploadColorSuccess = '[Color] Upload color success xlsx',
  UploadProcessUpdateColor = '[Color] Upload process update',
  UploadProcessSuccess = '[Color] Upload process success',
  UploadProcessFail = '[Color] upload process Fail color',
  ColorProcessSuccess = '[Color] Color process success',
  ColorProcessFail = '[Color] Color process fail',
  ColorProcessUpdate = '[Color] Color process update',
  DeleteColor = '[Color] Color delete',
  DeleteColorSuccess = '[Color] Color delete success',
}

export class Load implements Action {
  readonly type = ColorActionTypes.Load;
  constructor(public FollowId: number) {}
}

export class LoadSuccess implements Action {
  readonly type = ColorActionTypes.LoadSuccess;
  constructor(public colors: Color[]) {}
}

export class LoadFail implements Action {
  readonly type = ColorActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class AddOne implements Action {
  readonly type = ColorActionTypes.AddOne;
  constructor(public color: Color) {}
}

export class AddAll implements Action {
  readonly type = ColorActionTypes.AddAll;
  constructor(public colors: Color[]) {}
}

export class Create implements Action {
  readonly type = ColorActionTypes.Create;
  constructor(public followId: number, public color: Color) {}
}

export class CreateSuccess implements Action {
  readonly type = ColorActionTypes.CreateSuccess;
  constructor(public color: Color) {}
}

export class CreateFail implements Action {
  readonly type = ColorActionTypes.CreateFail;
  constructor(public error: any) {}
}

export class Update implements Action {
  readonly type = ColorActionTypes.Update;
  constructor(public followId: number, public data: any) {}
}

export class UpdateSuccess implements Action {
  readonly type = ColorActionTypes.UpdateSuccess;
  constructor(public colorId: number, public data: any) {}
}

export class UpdateFail implements Action {
  readonly type = ColorActionTypes.UpdateFail;
  constructor(public error: any) {}
}

export class UpdateOne implements Action {
  readonly type = ColorActionTypes.UpdateOne;
  constructor(public color: Color) {}
}

export class ExportColor implements Action {
  readonly type = ColorActionTypes.ExportColor;
  constructor(
    public id: number,
    public name: string,
    public exportType: string
  ) {}
}

export class ExportColorSuccess implements Action {
  readonly type = ColorActionTypes.ExportColorSuccess;
  constructor() {}
}

export class ExportColorFail implements Action {
  readonly type = ColorActionTypes.ExportColorFail;
  constructor() {}
}

export class GetUploadLink implements Action {
  readonly type = ColorActionTypes.GetUploadLink;
  constructor(
    public colorId: number,
    public file: any,
    public featured = false,
    public followId?: number
  ) {}
}

export class GetUploadLinkMassive implements Action {
  readonly type = ColorActionTypes.GetUploadLinkMassive;
  constructor(
    public colorId: number,
    public file: any,
    public featured = false
  ) {}
}
export class GetUploadLinkFailMassive implements Action {
  readonly type = ColorActionTypes.GetUploadLinkFailMassive;
  constructor(public error: any) {}
}

export class GetUploadLinkSuccessMassive implements Action {
  readonly type = ColorActionTypes.GetUploadLinkSuccessMassive;
  constructor(public link: string, public file: any) {}
}

export class GetUploadLinkFail implements Action {
  readonly type = ColorActionTypes.GetUploadLinkFail;
  constructor(public error: any) {}
}

export class GetUploadLinkSuccess implements Action {
  readonly type = ColorActionTypes.GetUploadLinkSuccess;
  constructor(public link: string, public file: any) {}
}

export class UploadFile implements Action {
  readonly type = ColorActionTypes.UploadFile;
  constructor(public link: string, public file: any, public followId?: number) {}
}
export class UploadFileSuccess implements Action {
  readonly type = ColorActionTypes.UploadFileSuccess;
  constructor(public followId?: any) {}
}

export class UploadFileFail implements Action {
  readonly type = ColorActionTypes.UploadFileFail;
  constructor(public error: any) {}
}

export class ProcessFile implements Action {
  readonly type = ColorActionTypes.ProcessFile;
  constructor() {}
}

export class ProcessFileUpdate implements Action {
  readonly type = ColorActionTypes.ProcessFileUpdate;
  constructor(public job: any) {}
}

export class ProcessFileSuccess implements Action {
  readonly type = ColorActionTypes.ProcessFileSuccess;
  constructor(public job: any, public uploadType: 'follow' | 'image') {}
}

export class ProcessFileFail implements Action {
  readonly type = ColorActionTypes.ProcessFileFail;
  constructor() {}
}

export class NotifyFileUpload implements Action {
  readonly type = ColorActionTypes.NotifyFileUpload;
  constructor(public id: string, public followId?: any) {}
}

export class AddPicture implements Action {
  readonly type = ColorActionTypes.AddPicture;
  constructor(public file: File) {}
}

export class AddToFileCount implements Action {
  readonly type = ColorActionTypes.AddToFileCount;
  constructor(public id: number) {}
}

export class GetColorsLink implements Action {
  readonly type = ColorActionTypes.GetColorsLink;
  constructor(
    public owner: any,
    public file: any,
    public uploadType: 'follow'
  ) {}
}

export class GetColorsLinkFail implements Action {
  readonly type = ColorActionTypes.GetColorsLinkFail;
  constructor(public error: any) {}
}

export class UploadColor implements Action {
  readonly type = ColorActionTypes.UploadColor;
  constructor(public link: any, public file: any, public followId?: number) {}
}

export class UploadColorSuccess implements Action {
  readonly type = ColorActionTypes.UploadColorSuccess;
  constructor(public data: any) {}
}

export class UploadColorFail implements Action {
  readonly type = ColorActionTypes.UploadColorFail;
  constructor(public error: any) {}
}

export class UploadProcessSuccess implements Action {
  readonly type = ColorActionTypes.UploadProcessSuccess;
  constructor(public data: any) {}
}

export class UploadProcessFail implements Action {
  readonly type = ColorActionTypes.UploadProcessFail;
  constructor(private error: any) {}
}

export class ColorProcessUpdate implements Action {
  readonly type = ColorActionTypes.ColorProcessUpdate;
  constructor(public data: any) {}
}

export class ColorProcessSuccess implements Action {
  readonly type = ColorActionTypes.ColorProcessSuccess;
  constructor() {}
}

export class ColorProcessFail implements Action {
  readonly type = ColorActionTypes.ColorProcessFail;
  constructor(public error: any) {}
}

export class UploadProcessUpdateColor implements Action {
  readonly type = ColorActionTypes.UploadProcessUpdateColor;
  constructor(public data: any) {}
}

export class DeleteColor implements Action {
  readonly type = ColorActionTypes.DeleteColor;
  constructor(public idColor: number, public followId: number) {}
}

export class DeleteColorSuccess implements Action {
  readonly type = ColorActionTypes.DeleteColorSuccess;
  constructor(public followId: any) {}
}

export type ColorActionsUnion =
  | Load
  | LoadSuccess
  | LoadFail
  | AddOne
  | AddAll
  | Create
  | CreateSuccess
  | Update
  | UpdateOne
  | UpdateSuccess
  | UpdateFail
  | ExportColor
  | ExportColorFail
  | ExportColorSuccess
  | CreateFail
  | GetUploadLink
  | GetUploadLinkFail
  | GetUploadLinkSuccess
  | UploadFile
  | UploadFileSuccess
  | UploadFileFail
  | NotifyFileUpload
  | ProcessFile
  | ProcessFileUpdate
  | ProcessFileFail
  | ProcessFileSuccess
  | AddPicture
  | AddToFileCount
  | GetUploadLinkMassive
  | GetUploadLinkFailMassive
  | GetUploadLinkSuccessMassive
  | GetColorsLink
  | GetColorsLinkFail
  | UploadColor
  | UploadColorFail
  | UploadColorSuccess
  | UploadProcessUpdateColor
  | UploadProcessSuccess
  | ColorProcessUpdate
  | ColorProcessSuccess
  | ColorProcessFail
  | UploadProcessFail
  | DeleteColor
  | DeleteColorSuccess;
